import { render, staticRenderFns } from "./SparkleDetailsIcon.vue?vue&type=template&id=f390b1e0&"
import script from "./SparkleDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./SparkleDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports